<template>
  <div>
    <TopBar :mode="mode" @toggle="$emit('toggle')">
      <span class="text-[21px] font-semibold custom:text-lg xl:hidden">
        {{ pageTitle }}
        <span v-if="$route.name === 'serp-keyword-spy'">
          - Find the boosting SEO keywords
        </span>
      </span>
    </TopBar>
    <div class="p-4" v-if="searchType !== 0">
      <div class="hidden items-center justify-between mb-4 xl:flex">
        <span class="text-[21px] font-semibold custom:text-lg">
          {{ pageTitle }}
          <span v-if="$route.name === 'serp-keyword-spy'">
            - Find the boosting SEO keywords
          </span>
        </span>
      </div>
      <SerpForm @submit="serpSearchSubmit" :type="searchType" :mode="mode" />
    </div>
  </div>
</template>

<script>
import helper from "../libs/helper";
import { useUserStore } from "../stores/user";
import TopBar from "@/components/TopBar.vue";
import SerpForm from "../components/SerpForm.vue";
export default {
  setup() {
    return {
      userStore: useUserStore(),
    };
  },
  props: {
    mode: String,
  },
  data() {
    return {
      searchType: 0,
      pageTitle: "",
    };
  },
  created() {
    if (!this.userStore.hasReportsPermission()) {
      this.$toast.error(
        "Your current subscription does not have access to this feature, please upgrade"
      );
      this.$router.push({
        name: "account-subscription",
      });
    }
  },
  mounted() {
    if (this.$route.name === "sitemap-analyzer") {
      this.searchType = helper.searchTypes.SitemapAnalyzer;
      this.pageTitle = "Sitemap Analyzer";
    } else if (this.$route.name === "serp-keyword-spy") {
      this.searchType = helper.searchTypes.TokenAnalysis;
      this.pageTitle = "Keyword Spy";
    } else {
      this.searchType = helper.searchTypes.SERPFinder;
      this.pageTitle = "Fresh SERP Finder";
    }
  },
  components: {
    TopBar,
    SerpForm,
  },
  methods: {
    async serpSearchSubmit(extractedError, uuid) {
      if (uuid) {
        this.$router.push({ name: "reports" });
      }
      if (extractedError) {
        this.userStore.setIsLoading(!1);
        this.$toast.error(extractedError.alert.message);
        if (extractedError.redirect) {
          this.userStore.signOut();
          this.$router.push({ name: extractedError.redirect });
        }
      }
    },
  },
};
</script>
